import { marked } from "marked";
import { fmtDateTimeFull } from "@extensions/utils";
import "./cyber.css";

const CyberMessage = ({ message }) => {
  return (
    <div className="cyber-message">
      <div className="cyber-message-meta" style={{ textAlign: "right" }}>
        {message.createdOn && fmtDateTimeFull(message.createdOn)}
      </div>
      {message.ask != null && message.ask !== "" && (
        <div className="cyber-message-block cyber-message-ask">
          {message.ask}
        </div>
      )}
      {message.answer != null && message.answer !== "" && (
        <div
          className="cyber-message-block cyber-message-answer cyber-markdown"
          dangerouslySetInnerHTML={{ __html: marked.parse(message.answer) }}
        />
      )}
    </div>
  );
};

export default CyberMessage;
